/**
 * First-class Finance FX pairs shared by Midpoint, CasaMapa, and AutoMapa.
 * Snapshot storage remains COP-based: 1 COP = X foreign currency.
 */
export const FINANCE_FX_BASE_CURRENCY = "COP";
export const FINANCE_FX_DEFAULT_CURRENCY = "USD";
/** Default chart window for Finance FX history panels (M4). */
export const FINANCE_FX_DEFAULT_HISTORY_DAYS = 90;
/** Public “Rates may be outdated” pill — last successful sync, not cache TTL. */
export const FINANCE_FX_STALE_AFTER_DAYS = 3;
/** CasaMapa market-intelligence table: newest snapshot dates only. */
export const FINANCE_FX_PUBLIC_TABLE_ROWS = 5;
export const FINANCE_FX_SPOTLIGHT_CURRENCIES = Object.freeze([
  "USD",
  "EUR",
  "RUB",
  "MXN",
]);

export function isFinanceFxSpotlightCurrency(value) {
  return FINANCE_FX_SPOTLIGHT_CURRENCIES.includes(
    String(value || "").trim().toUpperCase()
  );
}

export function buildFinanceFxPair(currency) {
  const code = String(currency || "").trim().toUpperCase();
  if (!code || code === FINANCE_FX_BASE_CURRENCY) return null;
  return `${code}/${FINANCE_FX_BASE_CURRENCY}`;
}
